import { ErrorHandler, Injectable, NgZone } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone) {}

  handleError(error: any): void {
    // Log the error with extra context (component stack if present)
    try {
      // Attempt to extract Angular debug context if available
      const debugCtx = (error && error.ngDebugContext) || (error && (error as any).rejection && (error as any).rejection.ngDebugContext);

      // Use zone.run to ensure logs show up in Angular context (useful when debugging)
      this.zone.run(() => {
        console.error('GlobalErrorHandler captured error: ', error);
        if (debugCtx) {
          try {
            const component = debugCtx.context && debugCtx.context.constructor && debugCtx.context.constructor.name;
            console.error('Component context:', component, debugCtx);
          } catch (e) {
            console.error('Failed to parse ngDebugContext', e);
          }
        }
      });
    } catch (e) {
      // fallback
      console.error('Error in GlobalErrorHandler', e);
      console.error('Original error', error);
    }

    // rethrow so the error still surfaces in console/stack
    throw error;
  }
}

